import { render, staticRenderFns } from "./JiJin.vue?vue&type=template&id=3b17ea40&scoped=true&"
import script from "./JiJin.vue?vue&type=script&lang=js&"
export * from "./JiJin.vue?vue&type=script&lang=js&"
import style0 from "./JiJin.vue?vue&type=style&index=0&id=3b17ea40&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b17ea40",
  null
  
)

export default component.exports